import { LoginRequest } from '@/features/auth/models/auth-login';
import { useAuthStore } from '@/features/auth/stores/auth.store';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { Box, Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { instanceToPlain } from 'class-transformer';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLogin } from '../queries/auth.mutations';
import { loginFormSchema } from './auth-login-form.schema';

const resolver = classValidatorResolver(LoginRequest);
export const LoginForm = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useLogin();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const { handleSubmit, control, setValue } = useForm<LoginRequest>({
    resolver,
    defaultValues: new LoginRequest()
  });

  return (
    <Dialog
      component='form'
      onSubmit={handleSubmit(async (data) => {
        const req = instanceToPlain(data);
        await mutateAsync(req);
        queryClient.invalidateQueries();
      })}
      open={!isAuthenticated}
      fullWidth
      maxWidth='xs'
    >
      <DialogContent>
        <Box className='mex:grid mex:grid-cols-12 mex:gap-y-3'>
          {loginFormSchema.map(({ name, render }) => (
            <Controller
              key={name}
              control={control}
              name={name}
              render={(params) => render({ ...params, control, setValue })}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions className=''>
        <Button type='submit' variant='contained' color='primary' fullWidth loading={isPending}>
          {t('auth.login.submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
